/**
 * Video Showcase — click a thumbnail to play the full video in a modal.
 * Handles both Shopify-hosted <video> and YouTube/Vimeo iframes.
 * Vanilla JS, no dependencies. Supports multiple showcase sections on one page.
 */
(function () {
  'use strict';

  function initShowcase(section) {
    var triggers = Array.prototype.slice.call(
      section.querySelectorAll('[data-video-trigger]')
    );
    if (!triggers.length) return;

    var modal = document.querySelector('[data-video-modal]');
    if (!modal) return;

    var panel = modal.querySelector('[data-video-modal-panel]');
    var contentEl = modal.querySelector('[data-video-modal-content]');
    var closeEls = modal.querySelectorAll('[data-video-close]');
    var lastFocusedTrigger = null;

    function stopPlayback() {
      var video = contentEl.querySelector('video');
      if (video) {
        video.pause();
      }
      var iframe = contentEl.querySelector('iframe');
      if (iframe) {
        // Clearing src stops YouTube/Vimeo playback reliably.
        iframe.src = iframe.src;
        iframe.remove();
      }
    }

    function open(index) {
      var template = section.querySelector(
        '[data-video-content="' + index + '"]'
      );
      if (!template) return;

      var orientation = template.getAttribute('data-video-orientation') || 'horizontal';
      panel.setAttribute('data-orientation', orientation);

      contentEl.innerHTML = '';
      contentEl.appendChild(template.content.cloneNode(true));

      lastFocusedTrigger = triggers[index];
      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      var video = contentEl.querySelector('video');
      if (video) {
        video.play().catch(function () {
          /* Autoplay may be blocked; user can press play manually. */
        });
      }

      var closeBtn = modal.querySelector('.video-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      stopPlayback();
      modal.hidden = true;
      contentEl.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocusedTrigger) lastFocusedTrigger.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = trigger.getAttribute('data-video-index');
        open(index);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') close();
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.video-showcase');
    sections.forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.video-showcase');
    if (section) initShowcase(section);
  });
})();